import SmartPolicies from '@data/models/SmartPolicies';
import { apiCall } from '../axios';
export class SmartPoliciesService {
    static getSmartPolicies(propertyId, language, policyId, checkinDate) {
        return apiCall(SmartPolicies)('get', '/getHumanReadableSmartPolicyText', {
            checkin_date: checkinDate,
            language_code: language,
            property_id: propertyId,
            smart_policy_id: policyId,
        });
    }
}
